import { render, staticRenderFns } from "./StaffTrajectory.vue?vue&type=template&id=94ab5dfc&scoped=true"
import script from "./StaffTrajectory.vue?vue&type=script&lang=ts"
export * from "./StaffTrajectory.vue?vue&type=script&lang=ts"
import style0 from "./StaffTrajectory.vue?vue&type=style&index=0&id=94ab5dfc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ab5dfc",
  null
  
)

export default component.exports